import React, { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  FormControl,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";
// Main components
import MainLayout from "../../../../components/main/layout/layout";
// Maintenance components
import MaintenanceForm from "../../../../components/maintenance/form/form";
// Actions
import * as mainActions from "../../../../redux/actions/main";
import * as paramsActions from "../../../../redux/actions/params";
// Styles
import "./form.css";

const SettingsParamsForm = ({ isNew }) => {
  const dispatch = useDispatch();
  const childRef = useRef();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);

  // Set constants
  const page = "settings";
  const primaryName = !isNew && !!form[`description`] ? form[`description`] : ``;

  // Get id from url
  const { id } = useParams();

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
    // Set initial breadscrum
    if (isNew) {
      const pathKey = 'new';
      const path = `settings_params/${pathKey}`;
      dispatch(mainActions.setBreadscrum(page, [{ path, pathKey: 'new-m' }]));
    } else {
      const pathKey = 'edit';
      const path = `settings_params/${pathKey}/${id}`;
      dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, }]));
    }    
  }, []);

  const handleChange = (evt) => {
    if (childRef.current) {
      childRef.current.handleChange(evt);
    }
  };

  const renderForm = () => {
    let title;
    if (isNew) {
      title = "Nou Paràmetre";
    } else {
      title = form[`code`];
    }

    return (
      <div className="maintenance-form-card">
        <div className="title maintenance-form-title">
          {title}
        </div>
        <FormControl isRequired>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Codi
          </FormLabel>
          <Input
            className="maintenance-form-field"
            placeholder="Codi"
            name="code"
            data-type={`string`}
            data-regex={"^[0-9a-zA-Z_-]*$"}
            data-uppercase={true}
            onChange={handleChange}
            value={form[`code`] ? form[`code`] : ``}
            disabled={!isNew}
            maxLength={50}
          />
        </FormControl>
        <FormControl isRequired mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Descripció
          </FormLabel>
          <Textarea
            className="maintenance-form-field"
            placeholder="Descripció"
            name="description"
            data-type={`string`}
            onChange={handleChange}
            value={form[`description`] ? form[`description`] : ``}
            maxLength={255}
          />
        </FormControl>
        <FormControl isRequired mt={4}>
          <FormLabel fontSize="sm" className="maintenance-form-label">
            Valor
          </FormLabel>
          <Textarea
            className="maintenance-form-field"
            placeholder="Valor"
            name="value"
            data-type={`string`}
            onChange={handleChange}
            value={form[`value`] ? form[`value`] : ``}
            maxLength={255}
          />               
        </FormControl> 
      </div>   
    );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="settings-params-form-content">
        <MaintenanceForm 
          primaryKey={"code"}
          primaryValue={id}
          primaryName={primaryName}
          config={{
            submitFields: [ 'code', 'description', 'value' ]
          }}
          menuConfig={{}}
          itemNameSingular={"Paràmetre"}
          actions={paramsActions} 
          setIsLoading={setIsLoading}
          renderForm={renderForm}
          form={form}
          setForm={setForm}
          isDirty={isDirty}
          setIsDirty={setIsDirty}
          ref={childRef}
          isNew={isNew}
          page={"settings_params"}
        />
      </div>
    </MainLayout>
  );
};

export default SettingsParamsForm;
